import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var truncateReactChildren = function truncateReactChildren(children, maxLength) {
  if (!children) {
    return [null, maxLength];
  }

  if (typeof children === "string") {
    var len = children.length;
    maxLength -= len;

    if (maxLength <= 0) {
      children = children.substr(0, children.length + maxLength);
    }

    return [children, maxLength];
  }

  function track(el) {
    if (maxLength > 0) {
      var _len = el.length;
      maxLength -= _len;

      if (maxLength <= 0) {
        el = el.substr(0, el.length + maxLength);
      }
    } else {
      el = void 0;
    }

    return el;
  }

  function walk(children2, fn) {
    var _a, _b;

    var props = __spreadValues({}, children2.props);

    if (typeof props.children === "string") {
      props.children = track(children2.props.children);
    } else {
      props.children = (_a = children2.props.children) == null ? void 0 : _a.map(function (child) {
        if (typeof child === "object") {
          child = walk(child, fn);
        } else if (typeof child === "string") {
          child = fn(child);
        }

        return child;
      });
    }

    if (!props.children) {
      children2 = void 0;
      props = void 0;
    }

    if (children2 && typeof children2 !== "string" && props.children && typeof props.children !== "string") {
      props.children = (_b = props.children) == null ? void 0 : _b.filter(function (child) {
        return child;
      });
    }

    return children2 && props ? __spreadProps(__spreadValues({}, children2), {
      props: props
    }) : void 0;
  }

  try {
    var upperlevelProps = walk(__spreadValues({}, children), track);
    return [__spreadValues({}, upperlevelProps), maxLength];
  } catch (er) {
    return [null, maxLength];
  }
};

export { truncateReactChildren };